"use client";
import Link from "next/link";
// import { Send } from "lucide-react";
import BrandLogo from "@/components/shared/BrandLogo";
// import { FaInstagram, FaYoutube, FaTwitter } from "react-icons/fa";
import { useState } from "react";
import toast from "react-hot-toast";

const navGroups = [
  {
    title: "Platform",
    links: [
      { label: "Home", href: "/#home" },
      { label: "Investment Plans", href: "/#plans" },
      { label: "Calculator", href: "/#calculator" },
      { label: "How It Works", href: "/#about" },
      { label: "Investment sectors", href: "/investment-sectors" },
    ],
  },
  {
    title: "Community",
    links: [
      { label: "Referral Program", href: "/#referral" },
      { label: "Stop-Loss", href: "/#stop-loss" },
      { label: "Testimonials", href: "/#testimonials" },
    ],
  },
  {
    title: "Support",
    links: [
      { label: "FAQ", href: "/#faq" },
      { label: "Contact Us", href: "/#contact" },
    ],
  },
];

// const socials = [
//   { Icon: Send, label: "Telegram", href: "#" },
//   { Icon: FaInstagram, label: "Instagram", href: "#" },
//   { Icon: FaYoutube, label: "YouTube", href: "#" },
//   { Icon: FaTwitter, label: "Twitter", href: "#" },
// ];

export default function Footer() {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const res = await fetch("/api/subscribe", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, source: "footer" }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        toast.error(data.error || "Subscription failed");
        return;
      }
      toast.success("Subscribed successfully");
      setEmail("");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <footer className="mt-16 border-t border-border bg-bg-primary px-4 pb-10 pt-16 md:px-4 lg:px-4 xl:px-5 2xl:px-6">
      <div className="mx-auto max-w-7xl">
        <div className="mb-14 grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-[minmax(220px,1.5fr)_repeat(3,minmax(140px,1fr))] lg:gap-12">
          <div>
            <div>
              <BrandLogo href="/" size="footer" variant="auto" />
            </div>
            <p className="max-w-[260px] text-sm leading-relaxed text-text-muted">
              High-yield investments, managed sectors, one platform. Built for
              investors who want clarity and control.
            </p>
          </div>

          {navGroups.map((group) => (
            <div key={group.title}>
              <div className="mb-4 text-xs font-bold uppercase tracking-[0.08em] text-text-primary">
                {group.title}
              </div>
              <div className="flex flex-col gap-2.5">
                {group.links.map((link) =>
                  link.href.startsWith("/") ? (
                    <Link
                      key={link.label}
                      href={link.href}
                      className="text-sm text-text-muted no-underline transition-colors hover:text-accent-amber"
                    >
                      {link.label}
                    </Link>
                  ) : (
                    <a
                      key={link.label}
                      href={link.href}
                      className="text-sm text-text-muted no-underline transition-colors hover:text-accent-amber"
                    >
                      {link.label}
                    </a>
                  ),
                )}
              </div>
              {group.title === "Support" ? (
                <>
                  {/* Social links — hidden for now
                  <div className="mt-5 flex gap-2.5">
                    {socials.map(({ Icon, label, href }) => (
                      <a
                        key={label}
                        href={href}
                        aria-label={label}
                        className="flex h-9 w-9 items-center justify-center rounded-lg border border-border bg-[rgba(255,255,255,0.05)] text-text-muted no-underline transition hover:border-accent-amber hover:bg-[rgba(245,158,11,0.08)] hover:text-accent-amber"
                      >
                        <Icon size={15} />
                      </a>
                    ))}
                  </div>
                  */}
                  <form onSubmit={subscribe} className="mt-5">
                    <p className="mb-2 text-xs uppercase tracking-[0.08em] text-text-primary">
                      Email Subscription
                    </p>
                    <div className="flex flex-col gap-2 sm:flex-row">
                      <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Enter your email"
                        className="w-full min-w-0 rounded-lg border border-border bg-bg-secondary px-3 py-2 text-sm text-text-primary"
                        required
                      />
                      <button
                        type="submit"
                        disabled={submitting}
                        className="shrink-0 rounded-lg bg-linear-to-r from-amber-500 to-orange-600 px-4 py-2 text-sm font-semibold text-black disabled:opacity-60"
                      >
                        {submitting ? "..." : "Join"}
                      </button>
                    </div>
                  </form>
                </>
              ) : null}
            </div>
          ))}
        </div>

        <div className="border-t border-border pt-7">
          <div className="flex flex-wrap items-center justify-between gap-4">
            <p className="text-xs text-text-muted sm:text-sm">
              © {new Date().getFullYear()} MineMe. All rights reserved.
            </p>
            <div className="flex flex-wrap gap-6">
              {[
                { label: "Terms of Service", href: "/terms" },
                { label: "Privacy Policy", href: "/privacy" },
                { label: "Cookie Policy", href: "/cookies" },
              ].map((item) => (
                <Link
                  key={item.label}
                  href={item.href}
                  className="text-xs text-text-muted no-underline transition-colors hover:text-text-primary sm:text-sm"
                >
                  {item.label}
                </Link>
              ))}
            </div>
          </div>

          <p className="mt-5 max-w-[800px] text-[11px] leading-relaxed text-[#555]">
            Risk Disclaimer: Investments involve risk. Past performance is not
            indicative of future results. MineMe does not provide financial
            advice. Please invest only what you can afford to lose and consult a
            qualified financial advisor before making investment decisions.
          </p>
        </div>
      </div>
    </footer>
  );
}
